module.exports = __webpack_public_path__ + "static/media/8.923bb2d1.png";